import { createFileRoute } from "@tanstack/react-router"
import { AccountLayout } from "@/components"

export const Route = createFileRoute("/_authenticated/_account")({
  component: AccountLayout,
})
